var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var MenuItems = function (props) { return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "#42526E" }, props, { children: [_jsx("rect", { x: "24", y: "24", width: "24", height: "24", rx: "5.4", transform: "rotate(180 24 24)" }), _jsx("g", { clipPath: "url(#clip0_334_574)", children: _jsx("path", { d: "M16.95 12.124L9.72446 12.124M9.72446 12.124L12.8211 9.59512M9.72446 12.124L12.8211 14.653", stroke: "#A3B3C1", strokeWidth: "0.9", strokeLinecap: "round" }) }), _jsx("defs", { children: _jsx("clipPath", { id: "clip0_334_574", children: _jsx("rect", { width: "13.2", height: "13.2", fill: "white", transform: "matrix(-1 0 0 -1 18.6 18.6)" }) }) })] }))); };
